import Common from '../../common/CommonNctv';

export let container= ()=>{
    let com = Common.instance;

    return `
<div class="visual-inner">
    <h2 class="visual-title" style="background-position-y: 17%;">NCTV</h2>
    <p class="visual-desc">NC 게임 속 모든 영상을 만나다! <span class="visual-desc-hide">언제, 어디서나 게임 속 친구들이 <br>플레이 하는 영상을 보실 수 있어요!</span></p>
    <a href="/about/index?tv=${com.ip}" class="btn is-big is-filled visual-more">
        <span class="btn-text">바로가기</span>
    </a>
</div>`;
};